import { petFieldsToNullify } from 'server/models/Listing/fieldgroups';

export default function getPetFieldsToNullify(excludeFields = []) {
  return petFieldsToNullify
    .filter((field) => !excludeFields.includes(field))
    .reduce(
      (memo, petField) => ({
        ...memo,
        [petField]: null,
      }),
      {},
    );
}
